import {
  ADD_PARTICIPANTS_REMINDERS,
  EDIT_PARTICIPANTS_REMINDERS,
  LIST_PARTICIPANTS_REMINDERS,
  VIEW_PARTICIPANTS_REMINDERS,
  DELETE_PARTICIPANTS_REMINDERS,
  ADD_PARTICIPANTS_REMINDERS_TEXT,
  EDIT_PARTICIPANTS_REMINDERS_TEXT,
  LIST_PARTICIPANTS_REMINDERS_TEXT,
  VIEW_PARTICIPANTS_REMINDERS_TEXT,
  DELETE_PARTICIPANTS_REMINDERS_TEXT,
  PARTICIPANTS_REMINDERS_SUCCESS,
  PARTICIPANTS_REMINDERS_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const PartcipantsReminders = (state = initialState, action) => {
  switch (action.type) {

    // add Invites
    case ADD_PARTICIPANTS_REMINDERS:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case PARTICIPANTS_REMINDERS_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case PARTICIPANTS_REMINDERS_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit Invites
    case EDIT_PARTICIPANTS_REMINDERS:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list Invites
    case LIST_PARTICIPANTS_REMINDERS:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view Invites
    case VIEW_PARTICIPANTS_REMINDERS:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete Invites
    case DELETE_PARTICIPANTS_REMINDERS:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add Invites
    case ADD_PARTICIPANTS_REMINDERS_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case PARTICIPANTS_REMINDERS_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case PARTICIPANTS_REMINDERS_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit Invites
    case EDIT_PARTICIPANTS_REMINDERS_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
        
      }
      break

    // list Invites
    case LIST_PARTICIPANTS_REMINDERS_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view Invites
    case VIEW_PARTICIPANTS_REMINDERS_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete Invites
    case DELETE_PARTICIPANTS_REMINDERS_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default PartcipantsReminders
